import { RootState } from 'store/root-reducer';

export const applicantSummarySelector = ({ applicant }: RootState) => applicant.summary;
